import React from "react";
import { useNavigate } from "react-router-dom";
import "../css/auth.css";

function VerifySuccess() {
  const navigate = useNavigate();

  return (
    <div className="auth-container">
      <h2 className="auth-title">✅ Verification Successful</h2>
      <p className="success-message">
        Your email has been verified. You can now log in to your account.
      </p>
      <button
        className="primary-button"
        onClick={() => navigate("/auth/login")}
      >
        Login Now
      </button>
    </div>
  );
}

export default VerifySuccess;
